/* Tiffany header behavior: desktop mega menus (.show pattern, .nav-bg expansion, .active-line), mobile drawer
   (.menu-toggleable-left.in, submenu panels with back row, promo tiles), desktop scrolled states (.scrolling /
   .scrolling-header-up), editor reveal of the selected menu item. Initialized through TC.init (load + section reload). */
(function () {
  'use strict';
  function boot() {
    if (!window.TC || !TC.init) return;
    TC.init('[data-tc-header]', function (root) {
      var mq = window.matchMedia('(min-width: 1200px)');
      var isDesktop = function () { return mq.matches; };
      var mainHeader = root.querySelector('[data-tc-main-header]');
      var navMain = root.querySelector('[data-tc-nav-main]');
      var nav = root.querySelector('[data-tc-drawer]');
      var toggler = root.querySelector('[data-tc-drawer-toggle]');
      var navBg = root.querySelector('[data-tc-nav-bg]');
      var line = root.querySelector('[data-tc-active-line]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-tc-nav-item]'));
      var alive = function () { return document.body.contains(root); };

      /* ---------- desktop mega menu ---------- */
      function menuOf(li) { return li.querySelector('[data-tc-mega]'); }
      function linkOf(li) { return li.querySelector('[data-tc-nav-link]'); }
      function placeLine(li) {
        if (!line) return;
        var a = linkOf(li); var ul = a.closest('ul');
        var r = a.getBoundingClientRect(), ur = ul.getBoundingClientRect();
        line.style.left = (r.left - ur.left) + 'px'; line.style.width = r.width + 'px'; line.classList.add('visible');
      }
      function closeAll() {
        items.forEach(function (li) { li.classList.remove('show'); var m = menuOf(li); if (m) m.classList.remove('show'); var a = linkOf(li); if (a) a.setAttribute('aria-expanded', 'false'); });
        if (navBg) navBg.style.setProperty('--expand-height', '0px');
        document.body.classList.remove('nav-expanded');
        if (line) line.classList.remove('visible');
      }
      function openItem(li) {
        if (!isDesktop()) return;
        closeAll();
        li.classList.add('show');
        var m = menuOf(li); var a = linkOf(li);
        if (m) { m.classList.add('show'); if (navBg) navBg.style.setProperty('--expand-height', m.offsetHeight + 'px'); }
        if (a) a.setAttribute('aria-expanded', 'true');
        document.body.classList.add('nav-expanded');
        placeLine(li);
      }
      items.forEach(function (li) {
        var a = linkOf(li); var timer;
        li.addEventListener('mouseenter', function () { if (!isDesktop()) return; clearTimeout(timer); timer = setTimeout(function () { openItem(li); }, 100); });
        li.addEventListener('mouseleave', function () { if (!isDesktop()) return; clearTimeout(timer); closeAll(); });
        li.addEventListener('focusout', function (e) { if (isDesktop() && !li.contains(e.relatedTarget)) closeAll(); });
        if (a) {
          a.addEventListener('focus', function () { if (isDesktop()) openItem(li); });
          a.addEventListener('click', function (e) {
            if (isDesktop()) return; /* desktop: the entry is a link; the panel opens on hover/focus */
            if (!menuOf(li)) return;
            e.preventDefault();
            li.classList.add('show'); nav.scrollTop = 0;
          });
        }
        var back = li.querySelector('[data-tc-nav-back]');
        if (back) back.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); li.classList.remove('show'); });
      });
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var open = items.some(function (li) { return li.classList.contains('show'); });
        if (isDesktop() && open) { e.preventDefault(); closeAll(); return; }
        if (!isDesktop() && nav.classList.contains('in')) { e.preventDefault(); closeDrawer(); if (toggler) toggler.focus(); }
      });

      /* ---------- mobile drawer ---------- */
      function positionDrawer() { if (!mainHeader) return; var r = mainHeader.getBoundingClientRect(); nav.style.top = Math.max(0, r.bottom) + 'px'; }
      function openDrawer() {
        positionDrawer();
        nav.classList.add('in'); nav.setAttribute('aria-hidden', 'false');
        if (toggler) toggler.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('nav-mobile-open');
        window.addEventListener('scroll', positionDrawer, { passive: true });
        window.addEventListener('resize', positionDrawer);
      }
      function closeDrawer() {
        nav.classList.remove('in'); nav.setAttribute('aria-hidden', 'true');
        if (toggler) toggler.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('nav-mobile-open');
        items.forEach(function (li) { li.classList.remove('show'); });
        window.removeEventListener('scroll', positionDrawer);
        window.removeEventListener('resize', positionDrawer);
      }
      if (toggler) toggler.addEventListener('click', function () { if (nav.classList.contains('in')) closeDrawer(); else openDrawer(); });
      var onMq = function () { closeAll(); closeDrawer(); if (!isDesktop()) { root.classList.remove('scrolling', 'scrolling-header-up'); if (navMain) navMain.style.minHeight = ''; } };
      if (mq.addEventListener) mq.addEventListener('change', onMq); else mq.addListener(onMq);

      /* drawer promo carousel counter */
      var promo = root.querySelector('[data-tc-drawer-promo]');
      if (promo && TC.carousel) {
        var car = TC.carousel(promo.querySelector('.counter-carousel-items'));
        var count = promo.querySelector('[data-tc-drawer-count]');
        if (car && count) {
          var slides = promo.querySelectorAll('.splide__slide').length;
          car.track.addEventListener('scroll', function () { var w = car.track.clientWidth || 1; var i = Math.round(car.track.scrollLeft / w) + 1; count.textContent = Math.min(slides, Math.max(1, i)) + '/' + slides; }, { passive: true });
        }
      }

      /* ---------- desktop scrolled states ---------- */
      var lastY = window.scrollY, fullHeight = 0;
      function measure() { if (!root.classList.contains('scrolling')) fullHeight = root.offsetHeight; }
      function onScroll() {
        if (!alive()) { window.removeEventListener('scroll', onScroll); return; }
        if (!isDesktop()) return;
        var y = window.scrollY;
        measure();
        if (y > fullHeight && fullHeight > 0) {
          if (!root.classList.contains('scrolling')) { if (navMain) navMain.style.minHeight = navMain.offsetHeight + 'px'; closeAll(); root.classList.add('scrolling'); }
          if (root.getAttribute('data-tc-sticky') === 'always') root.classList.add('scrolling-header-up');
          else if (y < lastY - 2) root.classList.add('scrolling-header-up'); else if (y > lastY + 2) root.classList.remove('scrolling-header-up');
        } else {
          root.classList.remove('scrolling', 'scrolling-header-up');
          if (navMain) navMain.style.minHeight = '';
        }
        lastY = y;
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { if (alive()) measure(); });
      document.addEventListener('tc:header:resize', function () { root.classList.remove('scrolling', 'scrolling-header-up'); if (navMain) navMain.style.minHeight = ''; measure(); });
      measure();

      /* ---------- editor: reveal the selected menu item ---------- */
      root.addEventListener('shopify:block:select', function (e) {
        var li = e.target.closest('[data-tc-nav-item]');
        var tile = e.target.closest('.counter-item');
        if (li) { if (isDesktop()) openItem(li); else { openDrawer(); li.classList.add('show'); } }
        else if (tile) { if (!isDesktop()) { openDrawer(); tile.scrollIntoView({ block: 'nearest', inline: 'start' }); } }
      });
      root.addEventListener('shopify:block:deselect', function () { closeAll(); if (!isDesktop()) closeDrawer(); });
      document.addEventListener('shopify:section:unload', function (e) { if (e.target === root.closest('.shopify-section')) { closeDrawer(); document.body.classList.remove('nav-expanded'); } });
    });
  }
  if (window.TC && TC.init) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
